import styled from 'styled-components';
import { Text12Light, Text13Bold } from '../../utils/Text/Text.styles';

export const BundleContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  width: 26.3rem;
  gap: 0.5rem;
  max-width: 64rem;
  border-radius: 0.8rem;
  background-color: #badaf7;
  padding: 0.4rem;
  position: relative;
`;

export const BundleItem = styled.div`
  position: relative;
  width: 12.5rem;
  aspect-ratio: 1;
  overflow: hidden;
  border-radius: 0.5rem;
  height: 100%;
  background-color: #fff;
`;

export const MediaFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: 'space-between';
  gap: 0.4rem;
  margin-top: 1rem;
  width: 100%;
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TimeText = styled(Text12Light)`
  font-weight: ${$purchased => !$purchased && '600'};
`;

export const RepresentativeMedia = styled.div`
  position: relative;
`;

export const FreePreviewWrapper = styled.div`
  border-radius: 4px;
  padding: 2px 6px;
  position: absolute;
  background: rgba(0, 0, 0, 0.56);
  z-index: 10;
  top: 2px;
  left: 2px;
  font-size: 1.1rem;
  font-weight: 500;
  color: #fff;
`;

export const CancelContainer = styled.div``;

export const CancelButton = styled(Text13Bold)`
  text-decoration-line: underline;
  cursor: pointer;
`;
